import * as React from 'react';
import { PersianMonthNames } from '../../../../enums/DateConsts';

import '../DatePicker.scss';

const MonthBlock = props => {
  return (
    <div className="monthBlock">
      {PersianMonthNames.map((month, i) => {
        return (
          <div key={i} className="monthCol" onClick={() => props.onMonthSelected(i + 1)}>
            {month}
          </div>
        );
      })}
    </div>
  );
};

export default MonthBlock;
